import common from '@/common/common'

const state = {
  name: '',
  role: parseInt(localStorage.getItem('role')) || '',
  user_id: '',
  brand_ids: [],
  project_ids: [],
  follower_id: '',
  roles: [],
  user_ids: [],
  email: '',
  admin_status: 0
}

const getters = {
  getName: state => state.name,
  getRole: state => state.role,
  getUserEmail: state => state.email,
  getRoles: state => state.roles,
  getUserId: state => state.user_id,
  getUserIds: state => state.user_ids,
  getFollowerId: state => state.follower_id,
  isSuper: state => state.role === common.RoleType['super'],
  isAdmin: state => state.role === common.RoleType['admin'],
  isScheduler: state => state.role === common.RoleType['scheduler'],
  isFollower: state => state.role === common.RoleType['follower'],
  isStreamerAdmin: state => state.role === common.RoleType['streamer_admin'],
  isFollowerAdmin: state => state.role === common.RoleType['follower_admin'],
  isBuyer: state => state.role === common.RoleType['buyer'],
  isBusiness: state => state.role === common.RoleType['business'],
  isTreasurer: state => state.role === common.RoleType['treasurer'],
  getAuthBrands: state => state.brand_ids,
  getAuthProjects: state => state.project_ids,
  isAdminStatus: state => state.admin_status,
}

const mutations = {
  set_user (state, data) {
    state.name = data.name
    state.email = data.email
    state.role = parseInt(data.role)
    state.user_id = data.user_id
    state.brand_ids = data.brand_ids
    state.project_ids = data.project_ids
    state.follower_id = data.follower_id
    localStorage.setItem('role', parseInt(data.role))
    state.roles = data.roles
    state.user_ids = data.user_ids
    state.admin_status = data.admin_status
  },
  delete_user () {
    state.name = ''
    state.email = ''
    state.role = ''
    state.roles = []
    state.user_id = ''
    state.user_ids = []
    state.brand_ids = []
    state.project_ids = []
    state.follower_id = ''
    localStorage.removeItem('role')
    state.admin_status = 0
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js